// IMPORT PACKAGE REFERENCES
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink } from 'react-router-dom';
import disclosureIndicator from '../../Images/disclosureIndicator.png';

// IMPORT PROJECT REFERENCES

import { fetchDevice } from '../State/Actions/DeviceActions';
import { DeviceList } from './DeviceList';
import { LoadingIndicator } from '../Shared/LoadingIndicator/LoadingIndicator';
import { Error } from '../Shared/Error/Error';

import { DeviceRowType } from './DeviceRowType';
import { DeviceRow } from './DeviceRow';
import { DeviceSection } from './DeviceSection';
import { DeviceDetails } from './DeviceDetails';


// COMPONENT

export class DeviceSections extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sections: props.sections,
            editing: props.editing,
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        let value = event.target.value;

        let sectionId = event.target.id.split(":")[0];
        let rowId = event.target.id.split(":")[1];
        let inputType = event.target.id.split(":")[2];
        let inputId = event.target.id.split(":")[3];

        let newState = Object.assign({}, this.state);

        if (event.target.type === "checkbox") {
            value = !(newState.sections[sectionId].rows[rowId].rowData);
        }

        if (inputType !== undefined && inputId !== undefined) {
            if (inputType === "alias") {
                if (parseInt(inputId) === 1) {
                    // Input ID 1 - Alias Name
                    newState.sections[sectionId].rows[rowId].rowName = value;
                } else {
                    // Input ID 2 - Alias Date
                    newState.sections[sectionId].rows[rowId].rowData = value;
                }
            }
        } else {
            newState.sections[sectionId].rows[rowId].rowData = value;
        }


        this.setState({ sections: newState.sections });
        this.props.handleUpdate(newState.sections, sectionId, rowId);
    }

    componentWillReceiveProps(props) {
        this.setState({ editing: props.editing, sections: props.sections });
    }
    
    render() {
        return (
            Object.keys(this.state.sections).map(sectionKey => {
                let section = this.state.sections[sectionKey];

                return (
                    <div key={sectionKey} className="device-detail-section">
                    <div className="card">
                        {/* SECTION HEADER */}
                        <div className="card-header">
                            { section.sectionName }
                        </div>

                        {/* SECTION ROWS */}
                        <ul className="list-group list-group-flush">
                        { Object.keys(section.rows).map(rowKey => {
                            let row = section.rows[rowKey];

                                if (row.rowType == DeviceRowType.BASIC) {
                                    return (
                                        <Fragment key={rowKey}>
                                            <li className="list-group-item">
                                                <div className="row centered">
                                                    <div className="col-6">
                                                        { row.rowName}
                                                    </div>
                                                    { row.disclosureIndicator ?
                                                        (<Fragment>
                                                            <div className="col-5">
                                                                <div>
                                                                    {/* <input disabled={!this.state.editing} value={row.rowData} onChange={this.handleChange} type="text" className="form-control section" id={section.uid + ":" +row.uid} aria-describedby="textHelp" placeholder="No value"></input> */}
                                                                </div>
                                                            </div>
                                                        <div className="col-1 disclosure-row">
                                                            <div>{ row.disclosureIndicator && <a className="disclosureButton right-detail collapsed" data-toggle="collapse" href={"#" + row.uid} role="button" aria-expanded="false" aria-controls="collapseExample"><img className="disclosureImage"  src={disclosureIndicator}></img></a> }</div>
                                                        </div></Fragment>) :
                                                        <div className="col-6">
                                                            <div><input disabled={!this.state.editing} value={row.rowData} onChange={this.handleChange} type="text" className="form-control section" id={section.uid + ":" + row.uid} aria-describedby="textHelp" placeholder="No value"></input></div>
                                                            <div>{ row.disclosureIndicator && <a className="disclosureButton right-detail collapsed" data-toggle="collapse" href={"#" + row.uid} role="button" aria-expanded="false" aria-controls="collapseExample"><img className="disclosureImage" src={disclosureIndicator}></img></a> }</div>
                                                        </div>
                                                    }
                                                  
                                                </div>

                                                { row.disclosureIndicator &&
                                                    <div className="collapse" id={row.uid}>
                                                        <div className="section-padding"></div>
                                                        <div>
                                                            { row.subsection }
                                                        </div> 
                                                    </div>
                                                } 
                                            </li>
                                        </Fragment>
                                    )
                                } else if (row.rowType == DeviceRowType.SWITCH) {
                                    return (
                                        <Fragment key={rowKey}>
                                            <li className="list-group-item">

                                                <div className="row centered">
                                                    <div className="col-sm">
                                                        { row.rowName}
                                                    </div>
                                                    <div className="col-sm">
                                                        <label className={"switch " + (!this.state.editing && 'inactive')}>
                                                            <input disabled={!this.state.editing} id={section.uid + ":" + row.uid} onChange={this.handleChange} type="checkbox" checked={row.rowData}/>
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>

                                                
                                            </li>
                                        </Fragment>
                                    )
                                } else if (row.rowType == DeviceRowType.NEW) {
                                    return (
                                        <Fragment key={rowKey}>
                                            <li className="list-group-item">
                                                { row.rowData }
                                            </li>
                                        </Fragment>
                                    )
                                } else if (row.rowType == DeviceRowType.ALIAS) {
                                    return (
                                        <Fragment key={rowKey}>
                                            <li className="list-group-item">
                                                <table className="full-width">
                                                    <tbody>
                                                        <tr>
                                                            <td className="form-left">
                                                                <input disabled={!this.state.editing} value={row.rowName} onChange={this.handleChange} type="text" className="left-detail form-control section" id={section.uid + ":" + row.uid + ":alias:1"} aria-describedby="textHelp" placeholder="No value"></input>
                                                            </td>
                                                            <td className="form-right">
                                                                <input disabled={!this.state.editing} value={row.rowData} onChange={this.handleChange} type="text" className="right-detail form-control section" id={section.uid + ":" + row.uid  + ":alias:2"} aria-describedby="textHelp" placeholder="No value"></input>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </li>
                                        </Fragment>
                                    )
                                } else if (row.rowType == DeviceRowType.AUTOSUGGEST) {
                                    return (
                                        <Fragment key={rowKey}>
                                            <li className="list-group-item">
                                                <table className="full-width">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                { row.rowName }
                                                            </td>
                                                            <td>
                                                                { row.rowData }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </li>
                                        </Fragment>
                                    )
                                } else if (row.rowType == DeviceRowType.EMPTY) {
                                    return (
                                        <Fragment key={rowKey}>
                                            <li className="list-group-item">
                                                { row.rowName }
                                            </li>
                                        </Fragment>
                                    )
                                } 
                        })}
                        </ul>
                    </div>
                    </div>
                )
            })
        );
    }
}

